(() => {
  if (customElements.get('beauty-advisor-modal')) return;

  class BeautyAdvisorModal extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('modal-dialog');
      if (!this.modal) return;

      this.triggerClickHandler = this.handleTriggerClick.bind(this);
      document.addEventListener('click', this.triggerClickHandler);
    }

    disconnectedCallback() {
      if (this.triggerClickHandler) document.removeEventListener('click', this.triggerClickHandler);
    }

    /**
     * Opens the dialog when a trigger anywhere on the page is clicked.
     * @param {object} evt - Event object.
     */
    handleTriggerClick(evt) {
      const trigger = evt.target.closest('.beauty-advisor-link');
      if (!trigger) return;

      evt.preventDefault();

      // Close the mobile menu drawer first, otherwise its overlay sits above the dialog.
      trigger.closest('main-menu')?.closeMenuDrawer?.();

      this.modal.open(trigger);
    }
  }

  customElements.define('beauty-advisor-modal', BeautyAdvisorModal);
})();
